import { render, staticRenderFns } from "./landZhuanAdd.vue?vue&type=template&id=1b273456"
import script from "./landZhuanAdd.vue?vue&type=script&lang=js"
export * from "./landZhuanAdd.vue?vue&type=script&lang=js"
import style0 from "./landZhuanAdd.vue?vue&type=style&index=0&id=1b273456&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports